import { FONT_FAMILY, GAME_WIDTH } from '../config/constants';
import { crispText } from './textUtils';
import { createGearButton } from './GearButton';
import { createInfoButton } from './InfoButton';
import { createHomeButton } from './HomeButton';

export class HUD {
  private levelText: Phaser.GameObjects.Text;
  private lastLevel = -1;
  private lastLevelName = '';

  constructor(scene: Phaser.Scene, onPause: () => void, onInfo?: () => void, onHome?: () => void) {
    // Background bar
    const bar = scene.add.graphics();
    bar.fillStyle(0x0d0d1a, 0.6);
    bar.fillRect(0, 0, GAME_WIDTH, 88);
    bar.lineStyle(2, 0x3a3a5a, 0.3);
    bar.lineBetween(0, 88, GAME_WIDTH, 88);

    this.levelText = crispText(scene.add.text(32, 24, 'Level: 1', {
      fontFamily: FONT_FAMILY,
      fontSize: '34px',
      color: '#aaaacc',
      fontStyle: 'bold',
    }));

    // Pause / settings gear button (top-right)
    createGearButton(scene, GAME_WIDTH - 52, 44, onPause);

    // Dev info button (to the left of the gear button)
    if (onInfo) {
      createInfoButton(scene, GAME_WIDTH - 136, 44, onInfo);
    }

    // Home button (to the left of the info button)
    if (onHome) {
      createHomeButton(scene, GAME_WIDTH - 220, 44, onHome);
    }
  }

  update(level: number, _cubesRemaining: number, levelName?: string): void {
    const name = levelName ?? '';
    if (level !== this.lastLevel || name !== this.lastLevelName) {
      this.lastLevel = level;
      this.lastLevelName = name;
      this.levelText.setText(name ? `Lv ${level}: ${name}` : `Level: ${level}`);
    }
  }
}
